'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingCircle = exports.LoadingSVG = exports.LoadingSpinner = exports.LoadingWrapper = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  0% {\n    stroke-dasharray: 0, ', ';\n    stroke-dashoffset: 0;\n  }\n\n  45% {\n    stroke-dasharray: ', ';\n    stroke-dashoffset: ', ';\n  }\n\n  100% {\n    stroke-dasharray: ', ';\n    stroke-dashoffset: ', ';\n  }\n'], ['\n  0% {\n    stroke-dasharray: 0, ', ';\n    stroke-dashoffset: 0;\n  }\n\n  45% {\n    stroke-dasharray: ', ';\n    stroke-dashoffset: ', ';\n  }\n\n  100% {\n    stroke-dasharray: ', ';\n    stroke-dashoffset: ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  0% {\n    transform: rotateZ(0deg);\n  }\n\n  100% {\n    transform: rotateZ(360deg);\n  }\n'], ['\n  0% {\n    transform: rotateZ(0deg);\n  }\n\n  100% {\n    transform: rotateZ(360deg);\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: ', 'px;\n  height: ', 'px;\n  transform: translate(-50%, -50%);\n\n  ', '\n'], ['\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: ', 'px;\n  height: ', 'px;\n  transform: translate(-50%, -50%);\n\n  ', '\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: ', 'px;\n  height: ', 'px;\n  display: inline-block;\n  animation: ', ';\n  animation-duration: 2s;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n\n  ', '\n'], ['\n  width: ', 'px;\n  height: ', 'px;\n  display: inline-block;\n  animation: ', ';\n  animation-duration: 2s;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n\n  ', '\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  width: ', 'px;\n  height: ', 'px;\n  position: relative;\n'], ['\n  width: ', 'px;\n  height: ', 'px;\n  position: relative;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  stroke: ', ' !important;\n  stroke-linecap: round;\n  stroke-dasharray: ', ';\n  stroke-dashoffset: 0;\n  animation-name: ', ';\n  animation-duration: 1.5s;\n  animation-timing-function: ease-in-out;\n  animation-iteration-count: infinite;\n\n  ', '\n'], ['\n  stroke: ', ' !important;\n  stroke-linecap: round;\n  stroke-dasharray: ', ';\n  stroke-dashoffset: 0;\n  animation-name: ', ';\n  animation-duration: 1.5s;\n  animation-timing-function: ease-in-out;\n  animation-iteration-count: infinite;\n\n  ', '\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getArcLength = function getArcLength(fraction, props) {
  return fraction * Math.PI * (props.size - props.thickness);
};

var animateCircle = function animateCircle(props) {
  return (0, _styledComponents.keyframes)(_templateObject, getArcLength(1, props), getArcLength(0.7, props) + ', ' + getArcLength(1, props), getArcLength(-0.2, props), getArcLength(0.7, props) + ', ' + getArcLength(1, props), getArcLength(-1, props));
};

var animateWrapper = (0, _styledComponents.keyframes)(_templateObject2);

var LoadingWrapper = exports.LoadingWrapper = _styledComponents2.default.div(_templateObject3, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.fullScreen && '\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    transform: none;\n  ';
});

LoadingWrapper.displayName = 'LoadingWrapper';
var LoadingSpinner = exports.LoadingSpinner = _styledComponents2.default.div(_templateObject4, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, animateWrapper, function (props) {
  return !props.isButton && !props.fullScreen && '\n    position: absolute !important;\n    top: 0;\n    left: 0;\n    line-height: ' + props.size + 'px;\n  ';
});

LoadingSpinner.displayName = 'LoadingSpinner';
var LoadingSVG = exports.LoadingSVG = _styledComponents2.default.svg(_templateObject5, function (props) {
  return props.size;
}, function (props) {
  return props.size;
});

LoadingSVG.displayName = 'LoadingSVG';
var LoadingCircle = exports.LoadingCircle = _styledComponents2.default.circle(_templateObject6, function (props) {
  return props.isButton ? 'rgba(255, 255, 255, 0.8)' : props.theme.color.primary;
}, function (props) {
  return getArcLength(0.85, props);
}, function (props) {
  return animateCircle(props);
}, function (props) {
  return props.color && '\n    stroke: ' + props.color + ' !important;\n  ';
});
LoadingCircle.displayName = 'LoadingCircle';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-loading/styles.js
// module id = 3014
// module chunks = 4